import React from "react";
import NumberFormat from "react-number-format";

export default function FormattedNumberInput(field) {
  const {
    onValueChange,
    className,
    fieldFormat,
    fieldMask,
    placeholder,
    min,
    max,
    rootClassName,
  } = field;

  return (
    <div className={rootClassName}>
      <NumberFormat
        className={className}
        type="text"
        format={fieldFormat}
        mask={fieldMask}
        placeholder={placeholder}
        onValueChange={onValueChange}
        aria-label={field["aria-label"]}
        {...field.input}
      />
    </div>
  );
}
